module.exports = __webpack_public_path__ + "img/logo.804c9a90.png";